<div class="comments-toggle" layout layout-align-items-center (click)="toggle()" margin-top>
  <span class="label">
    {{
      (isExpanded()
        ? 'app.evaluation_tab.form_details.comments.hide'
        : 'app.evaluation_tab.form_details.comments.show'
      ) | translate: { count: notes().length }
    }}
  </span>
  <rt-icon [name]="isExpanded() ? 'expand-less' : 'expand-more'" size="small" class="chevron" />
</div>

@if (isExpanded()) {
  <div class="comments" layout-vertical margin-top-small-x>
    @for (note of safeNotes(); track note.admin.id) {
      <rt-box variant="vertical border-light no-padding" class="comment">
        <div class="comment-header" layout layout-align-items-center>
          <rt-avatar
            [type]="note.admin.hasAvatar || !note.admin.initials ? 'image' : 'initials'"
            size="small"
            [imageSrc]="note.admin.photoThumbUrl"
            [initials]="note.admin.initials"
            iconName="person"
            context="admin"
          />
          <span class="comment-author">{{ note.admin.name }}</span>
        </div>

        @if (useProsemirror() && note.noteJson) {
          <div
            class="comment-note"
            prosemirrorDefaultConfig
            [prosemirrorRender]="note.noteJson"
            [prosemirrorRenderConfig]="ProsemirrorConfig"
          ></div>
        } @else {
          <div class="comment-note" [innerHTML]="note.safeNoteHtml"></div>
        }
      </rt-box>
    }
  </div>
}
